import { ApolloClient } from '@apollo/client';

import { ApolloFeaturedAdClient, IFeaturedAdResponse } from '../../featured-ad/Apollo/ApolloFeaturedAdClient';
import { IBlock, IPage, IPageFetcher } from '../page';

import { GET_PAGE_QUERY } from './queries/get-page';

interface IPageResponse {
    name: string;
    content: IFeaturedAdResponse[];
}

export class ApolloPageClient implements IPageFetcher {
    // eslint-disable-next-line @typescript-eslint/ban-types
    public constructor (private client: ApolloClient<object>) {}

    public async fetch (id: string): Promise<IPage> {
        try {
            const response = await this.client.query({
                query: GET_PAGE_QUERY,
                variables: {
                    id,
                },
            });

            if (response.errors && response.errors.length > 0) {
                throw response.errors;
            }

            return ApolloPageClient.transformPage(response.data.Page);
        } catch (error) {
            throw error;
        }
    }

    private static transformPage (page: IPageResponse): IPage {
        const {
            content,
        }: IPageResponse = page;

        const blocks: IBlock[] = content.map((contentBlock: IFeaturedAdResponse): IBlock => {
            return {
                type: 'FeaturedAd',
                content: ApolloFeaturedAdClient.transformFeaturedAdResponse(contentBlock),
            };
        });

        return {
            blocks,
        };
    }
}
